import { render, staticRenderFns } from "./AlarmRedirectTable.vue?vue&type=template&id=4e20fc06&"
import script from "./AlarmRedirectTable.vue?vue&type=script&lang=js&"
export * from "./AlarmRedirectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports